//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WordStudyChip from '@/components/innovation/WordStudyChip.vue'
export default {
  components: { WordStudyChip },
  data () { return { root: null, words: [], progress: null } },
  created () {
    const id = this.$route.query.id
    this.$ajax.get(this.$api.etRootDetail + '?id=' + id).then(r => {
      this.root = r.root; this.words = r.words || []
    })
    this.$ajax.get(this.$api.etRootProgress + '?root_id=' + id).then(r => {
      this.progress = r
    }).catch(() => {})
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/etymology-tree/root-detail.vue